import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type {
  TStore,
  TStoreData,
  TStoreFile,
} from "../../../services/api/instances/vectorStoreApi/types";
import {
  createLocalStoreFileReducerBuilder,
  createLocalStoreReducerBuilder,
  createStoreFileReducerBuilder,
  createStoreReducerBuilder,
  deleteFileReducerBuilder,
  deleteLocalFileReducerBuilder,
  deleteLocalStoreReducerBuilder,
  deleteStoreReducerBuilder,
  getLocalStoreFilesReducerBuilder,
  getLocalStoresReducerBuilder,
  getStoreFilesReducerBuilder,
  getStoresReducerBuilder,
  updateLocalStoreReducerBuilder,
  updateStoreReducerBuilder,
} from "./reducers";
import type { DatabaseState } from "./types";

const initialState: DatabaseState = {
  dataStore: [],
  selectedStore: null,
  fileList: [],
  storeType: "openai",
  isStoreLoading: false,
  isFileLoading: false,
  isFileUpload: false,
  hasMutation: true,
  mode: null,
};

const databaseSlice = createSlice({
  name: "database",
  initialState,
  reducers: {
    setStoreAction: (state, action: PayloadAction<TStoreData[]>) => {
      state.dataStore = action.payload;
    },

    setSelectedStore: (state, action: PayloadAction<TStoreData | null>) => {
      state.selectedStore = action.payload;
    },

    setSelectedFileList: (state, action: PayloadAction<TStoreFile[]>) => {
      state.fileList = action.payload;
    },

    setStoreType: (state, action: PayloadAction<TStore>) => {
      state.storeType = action.payload;
    },

    setMode: (state, action: PayloadAction<"edit" | "create" | null>) => {
      state.mode = action.payload;
    },
  },
  extraReducers: (builder) => {
    getStoresReducerBuilder(builder);
    createStoreReducerBuilder(builder);
    getStoreFilesReducerBuilder(builder);
    createStoreFileReducerBuilder(builder);
    updateStoreReducerBuilder(builder);
    updateLocalStoreReducerBuilder(builder);
    deleteFileReducerBuilder(builder);
    deleteStoreReducerBuilder(builder);
    getLocalStoresReducerBuilder(builder);
    getLocalStoreFilesReducerBuilder(builder);
    createLocalStoreFileReducerBuilder(builder);
    deleteLocalFileReducerBuilder(builder);
    deleteLocalStoreReducerBuilder(builder);
    createLocalStoreReducerBuilder(builder);
  },
});

export const databaseReducers = databaseSlice.reducer;
export const {
  setStoreAction,
  setSelectedStore,
  setSelectedFileList,
  setStoreType,
  setMode,
} = databaseSlice.actions;
